/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/devices/{id}`
 */
export interface DevicesIdPutRequest {
  /**
   * 设备类目
   */
  deviceTypeId?: number;
  /**
   * 设备列表
   */
  deviceList?: number[];
  /**
   * 数据属性列表
   */
  dataPropertyList?: number[];
  /**
   * 是否统一计算
   */
  unifiedCompute?: boolean;
  /**
   * Y轴倍率默认值，仅限数值型规则使用
   */
  yMagnificationValue?: number;
  /**
   * 累积量起始值默认值，仅限数值型规则使用
   */
  cumulativeStartValue?: number;
  id: string;
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/devices/{id}`
 */
export interface DevicesIdPutResponse {}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/devices/{id}`
 */
type ApiRulesSetDevicesIdPutRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/rulesSet/devices/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/devices/{id}`
 */
const apiRulesSetDevicesIdPutRequestConfig: ApiRulesSetDevicesIdPutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/rulesSet/devices/{id}',
  method: Method.PUT,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiRulesSetDevicesIdPut',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/devices/{id}`
 */
export const apiRulesSetDevicesIdPut = /*#__PURE__*/ (
  requestData: DevicesIdPutRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DevicesIdPutResponse>(prepare(apiRulesSetDevicesIdPutRequestConfig, requestData), ...args);
};

apiRulesSetDevicesIdPut.requestConfig = apiRulesSetDevicesIdPutRequestConfig;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/devices/{id}`
 */
export interface DevicesIdDeleteRequest {
  id: string;
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/devices/{id}`
 */
export interface DevicesIdDeleteResponse {}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/devices/{id}`
 */
type ApiRulesSetDevicesIdDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/rulesSet/devices/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/devices/{id}`
 */
const apiRulesSetDevicesIdDeleteRequestConfig: ApiRulesSetDevicesIdDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/rulesSet/devices/{id}',
  method: Method.DELETE,
  requestHeaders: {},
  requestBodyType: RequestBodyType.none,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiRulesSetDevicesIdDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/devices/{id}`
 */
export const apiRulesSetDevicesIdDelete = /*#__PURE__*/ (
  requestData: DevicesIdDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DevicesIdDeleteResponse>(prepare(apiRulesSetDevicesIdDeleteRequestConfig, requestData), ...args);
};

apiRulesSetDevicesIdDelete.requestConfig = apiRulesSetDevicesIdDeleteRequestConfig;

/* prettier-ignore-end */
